import { CHART_COLORS } from "@/shared/constants/common";

export const SERIES_COLORS = [
	CHART_COLORS.RED,
	CHART_COLORS.GREEN,
	CHART_COLORS.GOLD,
	CHART_COLORS.BLUE,
];

export const getColorByValue = (value: string, data: string[]) =>
	SERIES_COLORS[data.indexOf(value) % SERIES_COLORS.length];
